import React from "react";
import {Dictionary} from "../../Dictionary";

abstract class FormGroupElement extends React.Component<any, any> {
    protected dictionary: Dictionary = new Dictionary();

    protected createLabel() {
        const className = 'form-label' + (this.props?.required ? ' required' : '');
        return (
            <label htmlFor={this.props.id} className={className}>{
                this.props.labelText || this.dictionary.get[this.props.label || this.props.id]
            }</label>
        );
    }

    protected createHelp() {

        return (
            <>
                {this.props?.help &&
                    <small id={this.props.id + '-help'} className="form-text text-muted">
                        <i className="bi bi-info-circle-fill"></i> {this.dictionary.get[this.props.help]}
                    </small>}
            </>
        );
    }

    protected prepareProps(): {} | any {
        let props = {...this.props};

        props?.key && delete props.key;
        props?.label && delete props.label;
        props?.translate && delete props.translate;
        props?.labelText && delete props.labelText;

        if (props?.value && !props?.defaultValue) {
            props.defaultValue = props.value;
            delete props.value;
        }

        if (!props?.name) {
            props.name = props.id;
        }

        if (props?.help) {
            props['aria-describedby'] = props.id + '-help';
            delete props.help;
        }

        if (!props?.className) {
            props.className = "form-control form-control-sm";
        }

        props.required = typeof props?.required === 'boolean' ? props.required : false;

        return props;
    }
}

export default FormGroupElement;
